import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private executingCounter = 0;
  public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  start(): void {
    this.executingCounter++;

    if (this.executingCounter > 0) {
      this.loading$.next(true);
    }
  }

  stop(): void {
    if (this.executingCounter > 0) {
      this.executingCounter--;
    }

    if (this.executingCounter <= 0) {
      this.loading$.next(false);
    }
  }
}
